<template>
  <div class="w-full text-center text-sm">
    {{ t('common.dontHaveAnAccount') }}
    <RouterLink class="underline underline-offset-2" :to="{ name: 'Signup' }">{{
      t('common.signUp')
    }}</RouterLink>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
